module.exports = __webpack_public_path__ + "static/media/mom_logo.b450a9e1.png";